import { useDebounceValue } from '@/hooks';
import { useGameIntroStore } from '@/store';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Select } from 'antd';
import { useEffect, useState } from 'react';
import { REDIRECT_TYPE_OPTIONS } from '../Drawers/GameIntroductionForm/constants';

export const GameIntroFilter = () => {
  const { filter, setParams } = useGameIntroStore();
  const [searchText, setSearchText] = useState('');

  const [debouncedValue] = useDebounceValue(searchText, 500);

  useEffect(() => {
    setParams({ page: 1, search: debouncedValue });
  }, [debouncedValue]);

  return (
    <div className='flex justify-start gap-[6px] items-center'>
      <Input
        className='w-[300px]'
        prefix={<SearchOutlined className='text-[20px]' />}
        placeholder='タイトル'
        value={searchText}
        onChange={(e) => {
          setSearchText(e.target.value);
        }}
      />
      {/* <Select
        className='select-status-banner'
        defaultValue={null}
        onChange={(type) => setParams({ type, page: 1 })}
        options={REDIRECT_TYPE_OPTIONS as any}
        value={filter.type}
        placeholder='ステータス'
      />
      <Button
        color='danger'
        onClick={() => {
          setParams({ type: undefined, search: undefined });
          setSearchText('');
        }}
      >
        クリア
      </Button> */}
    </div>
  );
};
